import { AccountPreferredSizesCategories } from '@/components/content/Account/parts/AccountPreferredSizes/parts/AccountPreferredSizesCategories';
import { AccountPreferredSizesSelect } from '@/components/content/Account/parts/AccountPreferredSizes/parts/AccountPreferredSizesSelect';
import { AccountPreferredSizesSkeleton } from '@/components/content/Account/parts/AccountPreferredSizes/parts/AccountPreferredSizesSkeleton';
import { AccountInformationFormTitleSX } from '@/components/content/Account/styles/accountInformationForm';
import { Typography } from '@mui/material';
import { usePreferredSizes } from 'integration/hooks/usePreferredSizes';

type Props = Omit<ReturnType<typeof usePreferredSizes>, 'onInitPreferredSize'> & {
	gender?: string;
};

export const AccountPreferredSizesCard = ({
	preferredSizes,
	isLoadingPreferredSizes,
	selectedPreferredSize,
	selectedSizes,
	gender,
	onSelectPreferredSize,
	onChangePreferredSize,
	selectedSizesPreferredSize,
}: Props) => (
	<>
		<Typography sx={AccountInformationFormTitleSX}>TALLAS</Typography>

		{isLoadingPreferredSizes ? (
			<AccountPreferredSizesSkeleton />
		) : (
			<AccountPreferredSizesCategories
				preferredSizes={preferredSizes}
				selectedPreferredSizeCategory={selectedPreferredSize}
				selectedPreferredSizes={selectedSizes}
				gender={gender}
				onClick={onSelectPreferredSize}
			/>
		)}

		{selectedSizesPreferredSize && selectedPreferredSize ? (
			<AccountPreferredSizesSelect
				category={selectedPreferredSize}
				value={selectedSizes.find((item) => item.label === selectedPreferredSize)?.value || ''}
				sizes={selectedSizesPreferredSize}
				onChange={onChangePreferredSize}
			/>
		) : null}
	</>
);
